/* eslint-disable */
import React, { Component } from 'react'


import Svg,{
  Circle,
  Ellipse,
  G,
  LinearGradient,
  RadialGradient,
  Line,
  Path,
  Polygon,
  Polyline,
  Rect,
  Symbol,

  Use,
  Defs,
  Stop
} from 'react-native-svg';

export const SvgSetting = ({size}) => {
    return (  <Svg width={size} height={size} viewBox="0 0 30 30">
  <G fill="none" fill-rule="evenodd" transform="translate(1 1)">
    <Circle cx="14" cy="14" r="14" stroke="#FFFFFF"></Circle>
    <Circle cx="19.5" cy="14.052" r="2" stroke="#FFFFFF"></Circle>
    <Circle cx="13.526" cy="11" r="2" stroke="#FFFFFF"></Circle>
    <Circle cx="7.503" cy="18" r="2" stroke="#FFFFFF"></Circle>
    <Rect width="1" height="10" x="7" y="6" fill="#FFFFFF" rx=".5"></Rect>
    <Rect width="1" height="10" x="13" y="13" fill="#FFFFFF" rx=".5"></Rect>
    <Rect width="1" height="7" x="19" y="16" fill="#FFFFFF" rx=".5"></Rect>
    <Rect width="1" height="6" x="19" y="6" fill="#FFFFFF" rx=".5"></Rect>
    <Rect width="1" height="3" x="13" y="6" fill="#FFFFFF" rx=".5"></Rect>
  </G>
</Svg>)
}

